module.exports = __webpack_public_path__ + "img/case3.72c8473a.png";